import { Duration, DurationLikeObject, DurationOptions } from 'luxon';

/**
 * Register global override of Duration function [fromISOTime,valueOf,toString,toJSON].
 * to allow for use of default .NET Core Timespan string formatting ('c' type = 333.10:05:07.555).
 * https://learn.microsoft.com/en-us/dotnet/standard/base-types/standard-timespan-format-strings
 */
export function bookerBackendApiOverrideLuxonDurationMethods() {
    console.log('Register global override of Luxon Duration for .NET Core Timespan formatting support');

    Duration.fromISOTime = function (text: string, opts?: DurationOptions) {
        if (!text || text.length === 0) return Duration.fromObject({});
        if (text.toUpperCase().startsWith('P') || text.toUpperCase().startsWith('T')) return Duration.fromISO(text, opts);
        return timespanValueToDuration(text);
    };

    Duration.prototype.valueOf = function () {
        return durationToTimespanValue(this) as unknown as number;
    };

    Duration.prototype.toISOTime = function () {
        return durationToTimespanValue(this);
    };

    Duration.prototype.toJSON = function () {
        return durationToTimespanValue(this);
    };

    Duration.prototype.toString = function () {
        return durationToTimespanValue(this);
    };
}

function timespanValueToDuration(timespanValue: string): Duration {
    const durationObj: DurationLikeObject = {};

    const timespanSplit = timespanValue.split(':');
    for (let i = 0; i < 3; i++) {
        const valuePart = timespanSplit[i];
        if (valuePart === undefined) continue;

        if (i == 0) {
            const daysSplit = valuePart.split('.');
            if (daysSplit.length == 2) {
                durationObj.days = parseInt(daysSplit[0]!);
                durationObj.hours = parseInt(daysSplit[1]!);
            } else {
                durationObj.hours = parseInt(valuePart);
            }
        }
        if (i == 1) {
            //minutes
            durationObj.minutes = parseInt(valuePart);
        }
        if (i == 2) {
            //[seconds].[millieseconds][microseconds][nanoseconds]
            const secondsSplit = valuePart.split('.');
            if (secondsSplit.length == 2) {
                durationObj.seconds = parseInt(secondsSplit[0]!);
                durationObj.milliseconds = parseInt(secondsSplit[1]!.length > 3 ? secondsSplit[1]!.substring(0, 3) : secondsSplit[1]!);
            } else {
                durationObj.seconds = parseInt(valuePart);
            }
        }
    }
    return Duration.fromObject(durationObj);
}

function durationToTimespanValue(duration: Duration): string {
    const durationObject = duration.shiftTo('days', 'hours', 'minutes', 'seconds', 'milliseconds').toObject();
    return `${durationObject.days}.${padTwoDigits(durationObject.hours)}:${padTwoDigits(durationObject.minutes)}:${padTwoDigits(durationObject.seconds)}.${durationObject.milliseconds}`;
}

function padTwoDigits(value: number | undefined): string {
    return (value ?? 0).toString().padStart(2, '0');
}
